<template>
    <div>
        <b-card class="standardpage border-none">
            <b-card-header>
                <b-row>
                    <b-col cols="12" sm="6" class="text-right text-sm-left pt-1">
                        <i :class="reports.icon" class="mr-1"></i>
                        <span>{{ reports.title }}</span>
                    </b-col>
                </b-row>
            </b-card-header>

            <div v-show="!component" class="availtable datatable">
                <b-card class="w-100pct mb-2">
                    <b-card-body class="py-0">
                        <b-row v-if="!showfilter">

                            <b-col cols="12" sm="6" md="4" xl="3">
                                <b-form-group label-cols="12" label="Name" label-size="sm">
                                    <b-input-group>
                                        <b-form-input v-model="name" :debounce="reports.debounce"
                                            placeholder="Name"></b-form-input>
                                        <b-input-group-append>
                                            <b-button size="sm" variant="outline-secondary" :disabled="!name"
                                                @click="name = ''">
                                                <i class="fa fa-remove"></i>
                                            </b-button>
                                        </b-input-group-append>
                                    </b-input-group>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" sm="6" md="4" xl="3">
                                <b-form-group label-cols="12" label="Code" label-size="sm">
                                    <b-input-group>
                                        <b-form-input v-model="code" :debounce="reports.debounce"
                                            placeholder="Code"></b-form-input>
                                        <b-input-group-append>
                                            <b-button size="sm" variant="outline-secondary" :disabled="!code"
                                                @click="code = ''">
                                                <i class="fa fa-remove"></i>
                                            </b-button>
                                        </b-input-group-append>
                                    </b-input-group>
                                </b-form-group>
                            </b-col>

                            <b-col cols="12" sm="6" md="4" xl="3">
                                <b-form-group label-cols="12" label="Category" label-size="sm">
                                    <b-input-group>
                                        <b-form-input v-model="category" :debounce="reports.debounce"
                                            placeholder="Category"></b-form-input>
                                        <b-input-group-append>
                                            <b-button size="sm" variant="outline-secondary" :disabled="!category"
                                                @click="category = ''">
                                                <i class="fa fa-remove"></i>
                                            </b-button>
                                        </b-input-group-append>
                                    </b-input-group>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" sm="6" md="4" xl="3">
                                <b-form-group label="Enabled?" label-for="enabled" label-cols="12">
                                    <treeselect instanceId="enabled" type="number" v-model="enabled" :clearable="true"
                                        :options="enabled_options"></treeselect>
                                </b-form-group>
                            </b-col>

                        </b-row>
                    </b-card-body>
                </b-card>
                <div class="px-3">
                    <d-table classdivtable="availtable datatable" refid="reports" :icon="reports.icon"
                        :busy="reports.busy" :toolbarlibrary="reports.toolbarlibrary" :tools="reports.tools"
                        :badges="reports.badges" :fields="reports.fields" :items="reports.items" :limit="reports.limit"
                        :showpages="true" :offset="reports.offset" :page="reports.page" @load="reports_load"
                        @click="reports_click" @changed="reports_click('save', $event)" @select="reports_select">
                    </d-table>
                </div>
            </div>

            <div v-show="component">
                <component :is="component" :selection="reports.selected" :config="cconfig"
                    @discard="reports_click('discard')" @go="reports_click('go')"></component>
            </div>
            <!-- <b-card-footer class="mt-2 ml-1">
                <b-row>
                    <b-col class="nopadding text-center">
                        <b-button squared size="sm" variant="outline-primary" @click="$emit('discard')">
                            <i class="fa fa-bars mr-2"></i>All Codes
                        </b-button>
                    </b-col>
                </b-row>
            </b-card-footer> -->
        </b-card>
    </div>
</template>


<script>
import gql from "graphql-tag";

import ReportEdit from "./Components/Setup_ReportEdit";

export default {
    name: "Reports",
    components: { ReportEdit },
    watch: {
        async name() {
            await this.reports_load(0);
        },
        async category() {
            await this.reports_load(0);
        },
        async code() {
            await this.reports_load(0);
        },
        async enabled() {
            await this.reports_load(0);
        },
    },
    data() {
        return {
            name: null,
            category: null,
            code: null,
            enabled: null,
            enabled_options: [
                {
                    id: 1,
                    label: "Yes",
                },
                {
                    id: 0,
                    label: "No",
                },
            ],
            reports: {
                title: "Report Setup",
                icon: "fa fa-cog",
                debounce: 500,
                busy: false,
                page: 1,
                offset: 0,
                limit: 15,
                tools: "go,filter,export,clipboard,add,edit,deleteconfirm,reset",
                toolbarlibrary: [
                    {
                        type: "button",
                        size: "sm",
                        variant: "outline-white",
                        squared: "squared",
                        icon: "fa fa-power text-danger",
                        position: "toolbar",
                        action: "reset",
                        label: "Reset",
                        disabled: true,
                        component: {
                            name: "",
                        },
                    },

                ],
                fields: [
                    {
                        key: "selected",
                        label: "...",
                        class: "text-center w-25px",
                    },
                    {
                        key: "icon",
                        label: "",
                        class: "text-right w-50px",
                    },

                    {
                        key: "name",
                        label: "Name",
                        sortable: true,
                    },
                    {
                        key: "code",
                        label: "Code",
                        sortable: true,
                    },
                    {
                        key: "category",
                        label: "Category",
                        sortable: true,
                    },
                    {
                        key: "section",
                        label: "Section",
                        sortable: true,
                    },
                    {
                        key: "source",
                        label: "Source",
                        sortable: true,
                    },
                    {
                        key: "enabled",
                        label: "Enabled",
                        sortable: true,
                    },
                    {
                        key: "updated_by",
                        label: "Updated By",
                        sortable: true,
                        class: "text-center w-100px",
                    },
                    {
                        key: "updated_at",
                        label: "Updated At",
                        sortable: true,
                        class: "text-right w-100px",
                    },
                    {
                        key: "actions",
                        label: "Actions",
                        class: "actions w-100px",
                    },
                ],
                badges: [
                    {
                        key: "category",
                        type: "pill",
                        class: "white"
                    },
                    {
                        key: "section",
                        type: "pill",
                        class: "secondary"
                    },
                    {
                        key: "enabled",
                        type: "badge",
                        Yes: "success",
                        No: "danger",
                        formatter: (value, key, item) => {
                            if (value) {
                                return "Yes";
                            } else {
                                return "No";
                            }
                        },
                    },

                ],
                items: [],
                selected: [],
                denied: [],
            },
        };
    },
    async mounted() {
        this.accessdenied();
        await this.reports_load();
    },

    methods: {
        accessdenied() {
            this.reports.denied = [];
            if (!this.user.permissions.includes("setup_reports.admin")) {
                this.reports.denied.push("deleteconfirm");
                this.reports.denied.push("reset");
            }
            if (!this.user.permissions.includes("setup_reports.admin")) {
                this.reports.denied.push("add");
                this.reports.denied.push("save");
            }

        },

        async reports_load(offset, limit, page) {
            let state = this.reports;

            if (offset || offset == 0) {
                state.offset = offset
            }
            if (limit || limit == 0) {
                state.limit = limit
            }
            if (page) {
                state.page = page
            }

            state.busy = true;

            let variables = {
                offset: state.offset,
                limit: state.limit,
                category: this.category,
                name: this.name,
                code: this.code,
                enabled: this.enabled,
                dateformat: "DD/MM/YYYY",
            };
            console.log("variables", variables);

            try {
                const response = await this.$apollo.query({
                    query: gql`
               query setup_reports(
                $limit: Int
                $offset: Int
                $name: String
                $code: String
                $enabled: String
                $category: String
                $dateformat: String
              ) {
                setup_reports(
                  limit: $limit
                  offset: $offset
                  category: $category
                  name: $name
                  code: $code
                  enabled: $enabled
                  dateformat: $dateformat
                ) {
                  id
                  name
                  code
                  section
                  category
                  source
                  enabled                  
                  rows
                  updated_at
                  updated_by
                }
              }
            `,
                    variables,
                });

                // USE LOCAL VARIABLE
                if (limit == 0) {
                    state.selected = response.data.setup_reports
                } else {
                    state.items = []
                    state.items = response.data.setup_reports;
                }



            } catch (error) {
                console.log(error);
            }

            state.busy = false;
        },
        async reports_click(a, ss) {

            switch (a) {
                case "filter":
                    this.showfilter = !this.showfilter;
                    break;
                case "discard":
                    this.component = null;
                    await this.reports_load();
                    break;
                case "go":
                    this.component = null;
                    await this.reports_load();
                    break;
                case "add":
                case "edit":
                    this.component = "ReportEdit";
                    break;

                case "save":
                    this.saveit(ss);
                    break;

                case "delete":
                    this.deleteit(ss);
                    break;

                case "reset":
                    await this.reset(ss);
                    break;
            }
        },
        async reports_select(ss, tools) {

            let state = this.reports;

            state.selected = ss;
            let tool = null;

            if (tools) {
                let enabled = ["back", "save", "go", "filter", "add", "export", "reset", "clipboard"];
                enabled.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.disabled = false;
                    }
                });
                // == 1
                enabled = ["edit"];
                enabled.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.disabled = ss.length == 1 ? false : true;
                    }
                });
                // > 1
                enabled = ["deleteconfirm"];
                enabled.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.disabled = ss.length > 0 ? false : true;
                    }
                });

                if (!state.denied) {
                    state.denied = [];
                }
                state.denied.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.visible = false;
                    }
                });
            }
        },
        async reports_changed(ss) {
            console.log("reports_changed", ss);
            await this.saveit(ss);
        },

        async saveit(ss) {
            this.busy = true;

            let variables = { rows: this.cleanit(ss) };
            console.log("variables", variables);

            try {
                const response = await this.$apollo.mutate({
                    mutation: gql`
              mutation setup_reports_save(
                $rows: [setup_reports_input]
                $dateformat: String
              ) {
                setup_reports_save(rows: $rows, dateformat: $dateformat) {
                  id
                  category
                  name
                  code
                  section
                  source
                  enabled
                data
                }
              }
            `,
                    variables,
                });
                console.log(response);
                this.message = "<span class='text-primary'>Saved it.</span>";
            } catch (error) {
                this.message = "<span class='text-danger'>" + error.message + "</span>";
            }

            this.busy = false;
        },
        async deleteit(ss) {

            let rows = [];
            ss.forEach(function (v) {
                rows.push({ id: v.id });
            });

            let variables = {
                rows,
            };

            try {
                const response = await this.$apollo.mutate({
                    mutation: gql`
               mutation setup_reports_delete(
                $rows: [setup_reports_input]
              ) {
                setup_reports_delete(rows: $rows) {
                  id
  
                }
              }
            `,
                    variables,
                });
            } catch (error) {
                console.log(error);
            }

            await this.reports_load(0);
        },

        async reset(ss) {

            if (await this.$bvModal.msgBoxConfirm('Reports table will be reset to original values.', {
                title: 'Please confirm you want to reset the reports?',
                size: 'lg',
                buttonSize: 'sm',
                okVariant: 'success',
                okTitle: 'Yes',
                cancelTitle: 'No',
                footerClass: 'p-2',
                hideHeaderClose: false,
                centered: true
            })) {
                console.log("reset", ss);
                let state = this.reports

                state.busy = true

                try {
                    const response = await this.$apollo.mutate({
                        mutation: gql`
                        mutation setup_reports_reset {
                        setup_reports_reset
                }
          `,
                    });
                }
                catch (error) {
                    this.message = "<span class='text-danger'>" + error.message + "</span>";
                }
                state.busy = false
                await this.reports_load(0);

            } else {
                state.busy = false
            }
            await this.reports_load(0);

        },

    },
};
</script>

<style></style>